import { createContext, useContext, useState, ReactNode } from "react";

type AssetType = "ALGO" | { name: string; id: number; decimals: number };

interface TransactionInfo {
  recipient: string;
  amount: number;
  asset: AssetType;
  feeAlgo?: number;     // fee de la red
  feeProject?: number;  // fee interno del proyecto
  onConfirm: () => void;
}


interface TransactionContextType {
  showModal: boolean;
  txInfo: TransactionInfo | null;
  openTransactionModal: (info: TransactionInfo) => void;
  closeTransactionModal: () => void;
}

const TransactionContext = createContext<TransactionContextType>({
  showModal: false,
  txInfo: null,
  openTransactionModal: () => {},
  closeTransactionModal: () => {},
});

export const useTransaction = () => useContext(TransactionContext);

export const TransactionProvider = ({ children }: { children: ReactNode }) => {
  const [txInfo, setTxInfo] = useState<TransactionInfo | null>(null);
  const [showModal, setShowModal] = useState(false);

  const openTransactionModal = (info: TransactionInfo) => {
    setTxInfo(info);
    setShowModal(true);
  };

  const closeTransactionModal = () => {
    setShowModal(false);
    setTxInfo(null);
  };

  return (
    <TransactionContext.Provider value={{ showModal, txInfo, openTransactionModal, closeTransactionModal }}>
      {children}
    </TransactionContext.Provider>
  );
};

